import querystring, { type ParsedUrlQueryInput } from 'querystring';
import { ServiceNames } from './serviceNames';

interface FetchrConfig {
    apiUrl: string;
}

export const offerService = {
    resource: ServiceNames.OFFER_SERVICE,

    // all the object types are probably wrong, but might be missing proper type definitions
    read: async (
        _req: unknown,
        _resource: unknown,
        params: ParsedUrlQueryInput,
        config: FetchrConfig,
        callback: (error: unknown, response: unknown) => unknown,
    ): Promise<void> => {
        let { apiUrl } = config;
        if (apiUrl === undefined) {
            // @ts-expect-error _req.apiUrk is not defined in unknown
            apiUrl = _req.apiUrl;
        }
        const url = `${apiUrl}/offers?${params ? querystring.stringify(params) : ''}`;
        try {
            const response = await fetch(url);
            const json = await response.json();

            callback(null, json);
        } catch (e) {
            callback(e, { reason: `failed fetching from ${url}` });
        }
    },
};
